/**
 * @generated SignedSource<<ca82ef11bd4e011e55aa3ddf591c3637>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivitySource = "CABANA" | "SIPGATE" | "STRIPE" | "ZAMMAD" | "%future added value";
export type ContactActivityViewRefreshQuery$variables = {
  contactIdentifier: string;
  first?: number | null | undefined;
  offset?: number | null | undefined;
};
export type ContactActivityViewRefreshQuery$data = {
  readonly contactActivities: {
    readonly activities: ReadonlyArray<{
      readonly actorName: string | null | undefined;
      readonly body: string | null | undefined;
      readonly id: string;
      readonly metadata: any;
      readonly occurredAt: any;
      readonly source: ActivitySource;
      readonly type: string;
    }>;
    readonly hasMore: boolean;
    readonly totalCount: number;
  };
};
export type ContactActivityViewRefreshQuery = {
  response: ContactActivityViewRefreshQuery$data;
  variables: ContactActivityViewRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contactIdentifier"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offset"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contactIdentifier",
        "variableName": "contactIdentifier"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      }
    ],
    "concreteType": "ActivityResult",
    "kind": "LinkedField",
    "name": "contactActivities",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activities",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occurredAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metadata",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actorName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasMore",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactActivityViewRefreshQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactActivityViewRefreshQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d4b5e5221d129e61cbafc1ad45e735c3",
    "id": null,
    "metadata": {},
    "name": "ContactActivityViewRefreshQuery",
    "operationKind": "query",
    "text": "query ContactActivityViewRefreshQuery(\n  $contactIdentifier: ID!\n  $first: Int\n  $offset: Int\n) {\n  contactActivities(contactIdentifier: $contactIdentifier, first: $first, offset: $offset) {\n    activities {\n      id\n      source\n      type\n      occurredAt\n      metadata\n      actorName\n      body\n    }\n    totalCount\n    hasMore\n  }\n}\n"
  }
};
})();

(node as any).hash = "d5134ccd07fe0e7b616ee81b1826f939";

export default node;
